
export const authEndpoints = (builder) => ({
  // login: returns { token, user, ... } (adjust according to your backend)
  login: builder.mutation({
    query: (credentials) => ({
      url: '/auth/login',
      method: 'POST',
      body: credentials,
    }),
    // Optionally you can invalidate tags on login/register if needed
  }),

  // register: returns { token?, user?, ... } depending on your backend contract
  register: builder.mutation({
    query: (payload) => ({
      url: '/auth/register',
      method: 'POST',
      body: payload,
    }),
  }),

  // optional "me" endpoint if your backend supports it (uncomment if needed)
  // getMe: builder.query({
  //   query: () => ({ url: '/auth/me', method: 'GET' }),
  //   providesTags: [{ type: 'Auth', id: 'ME' }],
  // }),
});
